import { render, staticRenderFns } from "./AppUpload.vue?vue&type=template&id=1ec93fc3&scoped=true&"
import script from "./AppUpload.vue?vue&type=script&lang=js&"
export * from "./AppUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec93fc3",
  null
  
)

export default component.exports